import { useLocation } from 'react-router-dom'

const useFirstPathnameSegment = () => {
  const { pathname } = useLocation()
  return pathname.split('/')[1]
}

export default useFirstPathnameSegment
